import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0427e5f0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0427e5f0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0427e5f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0427e5f0')) {
      api.createRecord('0427e5f0', component.options)
    } else {
      api.reload('0427e5f0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0427e5f0&scoped=true", function () {
      api.rerender('0427e5f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popover/index.vue"
export default component.exports